/* Gray & Ashe redesign — interactions for Hair Oil + DHT guide sections (no dependencies) */
(function(){
  if (window.GARedesign) { window.GARedesign.init(document); return; }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('ga-js');
  function $$(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); }

  /* reveal on scroll */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  },{rootMargin:'0px 0px -8% 0px'}) : null;
  function reveals(root){ $$('.ga-rv:not(.is-in)', root).forEach(function(el){ if(io && !reduce) io.observe(el); else el.classList.add('is-in'); }); }

  /* count-ups */
  function counts(root){
    $$('[data-ga-count]', root).forEach(function(el){
      if (el.dataset.gaDone) return; el.dataset.gaDone = 1;
      var end = parseFloat(el.dataset.gaCount), dec = parseInt(el.dataset.gaDec||'0',10);
      if (isNaN(end) || reduce || !io) return;
      var o = new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting) return; o.disconnect();
        var t0 = performance.now(), d = 2000;
        (function step(t){ var p = Math.min(1,(t-t0)/d); p = 1-Math.pow(1-p,3); el.textContent = (end*p).toFixed(dec); if(p<1) requestAnimationFrame(step); })(t0);
      }); },{threshold:.4}); o.observe(el);
    });
  }

  /* compare toggle */
  function compare(root){
    $$('[data-ga-seg]', root).forEach(function(seg){
      if (seg.dataset.gaDone) return; seg.dataset.gaDone = 1;
      var cmp = seg.closest('section').querySelector('.ga-cmp');
      $$('button', seg).forEach(function(b){ b.addEventListener('click', function(){
        $$('button', seg).forEach(function(x){ x.setAttribute('aria-pressed', x===b ? 'true':'false'); });
        if (cmp) cmp.dataset.show = b.dataset.v;
      }); });
    });
  }

  /* timeline progress */
  var tls = [];
  function timelines(root){ $$('[data-ga-tl]', root).forEach(function(t){ if(tls.indexOf(t)<0) tls.push(t); }); onScroll(); }

  /* molecule sticky steps */
  var mols = [];
  function molecules(root){
    $$('[data-ga-mol]', root).forEach(function(sec){
      if (sec.dataset.gaDone) return; sec.dataset.gaDone = 1;
      var steps = $$('.ga-ms', sec), ticks = $$('.ga-moltick i', sec), chip = sec.querySelector('[data-ga-fchip]'), label = sec.querySelector('.ga-mlabel');
      var pinnable = !reduce && window.innerHeight > 500;
      if (pinnable) { sec.classList.add('is-pinnable'); sec.style.height = (steps.length*50+60)+'svh'; }
      var stage = null, stageEl = sec.querySelector('[data-ga-molstage]');
      function makeStage(){ if (stage || !window.GAMolecule || !stageEl) return; try { stage = new window.GAMolecule(stageEl, label); } catch(e){ console.warn(e); } }
      makeStage(); if (!stage) { var tries = 0, iv = setInterval(function(){ makeStage(); if (stage || ++tries > 40) { clearInterval(iv); if(stage) set(cur<0?0:cur, true); } }, 150); }
      var cur = -1;
      function set(i, force){
        if (i === cur && !force) return; cur = i;
        steps.forEach(function(s,k){ s.classList.toggle('is-on', k===i); });
        ticks.forEach(function(t,k){ t.classList.toggle('is-on', k<=i); });
        var st = steps[i]; if (!st) return;
        if (chip && st.dataset.formula) chip.textContent = st.dataset.formula;
        if (label) label.style.opacity = st.dataset.mode === 'target' ? 1 : 0;
        if (stage) stage.to(st.dataset.mode || 'start');
      }
      mols.push({sec:sec, steps:steps, set:set, pinnable:pinnable});
      set(pinnable ? 0 : steps.length-1, true);
    });
    onScroll();
  }

  function onScroll(){
    var vh = window.innerHeight;
    tls.forEach(function(t){ var r = t.getBoundingClientRect(); var p = (vh*0.82 - r.top)/(r.height + vh*0.25); p = Math.max(0, Math.min(1, p)); t.style.setProperty('--p', reduce ? 1 : p.toFixed(3)); });
    mols.forEach(function(m){ if(!m.pinnable) return; var r = m.sec.getBoundingClientRect(); var tot = r.height - vh; var p = tot>0 ? Math.max(0, Math.min(.999, -r.top/tot)) : 0; m.set(Math.floor(p*m.steps.length)); });
    rail && railUpdate();
  }
  window.addEventListener('scroll', onScroll, {passive:true}); window.addEventListener('resize', onScroll);

  /* purchase form: qty */
  function purchase(root){
    $$('[data-ga-buy]', root).forEach(function(form){
      if (form.dataset.gaDone) return; form.dataset.gaDone = 1;
      var q = form.querySelector('input[name="quantity"]');
      $$('[data-ga-q]', form).forEach(function(b){ b.addEventListener('click', function(){ var v = parseInt(q.value||'1',10)+parseInt(b.dataset.gaQ,10); q.value = Math.max(1, Math.min(99, v)); }); });
    });
  }

  /* hair cycle */
  function cycles(root){
    $$('[data-ga-cycle]', root).forEach(function(sec){
      if (sec.dataset.gaDone) return; sec.dataset.gaDone = 1;
      var r = sec.querySelector('input[type=range]'); if(!r) return;
      var A=[4,3.2,2.3,1.5,.9,.5], W=[1,.82,.64,.48,.34,.22];
      var hair=sec.querySelector('[data-hair]'), bulb=sec.querySelector('[data-bulb]'), pap=sec.querySelector('[data-pap]');
      var frames=$$('[data-frame]', sec);
      function q(s){ return sec.querySelector(s); }
      function set(n){ var i=n-1, a=A[i], w=W[i]; r.setAttribute('aria-valuetext','Cycle '+n); r.style.setProperty('--fill',((n-1)/5*100)+'%');
        q('[data-bar-a]').style.width=(a/4*100)+'%'; q('[data-out-a]').textContent=a.toFixed(1)+' yrs';
        q('[data-bar-t]').style.width=((3+i*.6)/6*100)+'%'; q('[data-out-t]').textContent=Math.round(3+i*.6)+' mo';
        q('[data-bar-w]').style.width=(w*100)+'%'; q('[data-out-w]').textContent=Math.round(w*100)+'%';
        frames.forEach(function(f,k){ f.classList.toggle('is-on', k===i); });
        if (!hair) return;
        var hw=4+12*w, hy=10+(1-a/4)*150, cy=250+12*w, ry=14+18*w;
        hair.setAttribute('x',100-hw/2); hair.setAttribute('width',hw); hair.setAttribute('rx',hw/2); hair.setAttribute('y',hy); hair.setAttribute('height',262-hy);
        bulb.setAttribute('rx',10+16*w); bulb.setAttribute('ry',ry); bulb.setAttribute('cy',cy); pap.setAttribute('r',4+7*w); pap.setAttribute('cy',cy+8*w);
      }
      r.addEventListener('input', function(){ set(+r.value); }); set(+r.value||1);
    });
  }

  /* Norwood stage finder */
  var ST={1:{f:[40,6],t:[6,8],m:[0,0],c:0},2:{f:[42,10],t:[14,24],m:[0,0],c:0},3:{f:[44,16],t:[18,34],m:[0,0],c:0},4:{f:[46,24],t:[20,40],m:[0,0],c:15},5:{f:[50,34],t:[24,46],m:[22,28],c:24},6:{f:[56,48],t:[28,54],m:[40,56],c:32},7:{f:[62,60],t:[34,62],m:[56,80],c:44}};
  function stages(root){
    $$('[data-ga-stage]', root).forEach(function(sec){
      if (sec.dataset.gaDone) return; sec.dataset.gaDone = 1;
      var r = sec.querySelector('input[type=range]'), data = [];
      $$('[data-stage-copy]', sec).forEach(function(el){ data.push(el); });
      function attr(sel, a){ var el = sec.querySelector(sel); if(!el) return; for (var k in a) el.setAttribute(k, a[k]); }
      function set(n){ var s=ST[n]; r.value=n; r.setAttribute('aria-valuetext','Stage '+n); r.style.setProperty('--fill',((n-1)/6*100)+'%');
        $$('[data-s]', sec).forEach(function(b){ b.classList.toggle('is-on', +b.dataset.s===n); });
        attr('[data-m=front]',{rx:s.f[0],ry:s.f[1]}); attr('[data-m=tl]',{rx:s.t[0],ry:s.t[1],cx:58+s.t[0]*.3}); attr('[data-m=tr]',{rx:s.t[0],ry:s.t[1],cx:142-s.t[0]*.3}); attr('[data-m=mid]',{rx:s.m[0],ry:s.m[1]}); attr('[data-m=crown]',{rx:s.c,ry:s.c});
        data.forEach(function(el){ el.hidden = +el.dataset.stageCopy !== n; });
      }
      r.addEventListener('input', function(){ set(+r.value); });
      $$('[data-s]', sec).forEach(function(b){ b.addEventListener('click', function(){ set(+b.dataset.s); }); });
      set(+r.value||2);
    });
  }

  /* floating chapter rail (desktop) */
  var rail = null, railLinks = [];
  function buildRail(){
    var chs = $$('[data-ga-chapter]'); if (chs.length < 3) return;
    if (!rail){ rail = document.createElement('nav'); rail.className = 'ga-rail'; rail.setAttribute('aria-label','Chapters'); document.body.appendChild(rail); }
    document.documentElement.classList.add('ga-has-rail');
    rail.innerHTML = ''; railLinks = [];
    chs.forEach(function(ch){ var a = document.createElement('a'); a.href = '#'+ch.id; a.innerHTML = '<span>'+(ch.dataset.gaNum||'')+'</span>'+ch.dataset.gaChapter; rail.appendChild(a); railLinks.push([a, ch]); });
  }
  function railUpdate(){
    if (!rail || !railLinks.length) return; var vh = window.innerHeight, first = railLinks[Math.min(1, railLinks.length-1)][1].getBoundingClientRect(), last = railLinks[railLinks.length-1][1].getBoundingClientRect();
    rail.classList.toggle('is-visible', first.top < vh*0.6 && last.bottom > vh*0.3);
    var on = null; railLinks.forEach(function(p){ var r = p[1].getBoundingClientRect(); if (r.top < vh*0.5) on = p[0]; });
    railLinks.forEach(function(p){ p[0].classList.toggle('is-on', p[0]===on); });
  }

  function init(root){ reveals(root); counts(root); compare(root); timelines(root); molecules(root); purchase(root); cycles(root); stages(root); buildRail(); onScroll(); }
  window.GARedesign = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();